import React from "react";
import About from "./Components/About";
import Certifications from "./Components/Certifications";
import Contact from "./Components/Contact";
import Navbar from "./Components/Navbar";
import Projects from "./Components/Projects";
import Skills from "./Components/Skills";
// import Testimonials from "./Components/Testimonials";
// import Badge from "./Components/Badge";

export default function App() {
  return (
    <main className="text-gray-400 bg-gray-900 body-font">
      <Navbar />
      <About />
      <Projects />
      <Skills />
      {/* <Testimonials /> */}
      <Certifications />
      {/* <Badge /> */}
      <Contact />
    </main>
  );
}


// WEBPACK FOOTER //
// ./src/App.js